import gql from "graphql-tag";

export let GET_PROPERTY_UNITS = (offset, limit, searchText, params) => gql`
query GET_PROPERTY{
  count: property(
    where:{
        name:{iregex:"${searchText}"}
        is_active:{eq:true}
        company_id:"${params?.company_id}"
        ${params?.revenue_type?.length > 0 ? `revenue_type: ${params?.revenue_type}` : ``}

    }
  ) {
    count:count_id
  }
 unit:property(
      where:{
           name:{iregex:"${searchText}"}
           company_id:"${params?.company_id}"
           is_active:{eq:true}
           ${params?.revenue_type?.length > 0 ? `revenue_type: ${params?.revenue_type}` : ``}

         }
      offset:${offset}
      limit:${limit}
    ){
         label:name
         label1:property_no
         value:id
         url:logo

      }
}
`;

export let GET_PROPERTY_UNIT = (offset, limit, searchText, params) => gql`
query GET_PROPERTY{
  count: property(
    where:{
        name:{iregex:"${searchText}"}
        is_active:{eq:true}
        company_id:"${params?.company_id}"
    }
  ) {
    count:count_id
  }
 unit:property(
      where:{
           name:{iregex:"${searchText}"}
           company_id:"${params?.company_id}"
           is_active:{eq:true}
         }
      offset:${offset}
      limit:${limit}
    ){
         label:name
         property_no
         value:id
         url:logo
         label1:total_area
         uom_master{
           name
         }

      }
}
`;